"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DROPDOWN_SUBTITLE = exports.DEFAULT_BUTTON_LABEL = void 0;
exports.DEFAULT_BUTTON_LABEL = 'Скачать приложение';
exports.DEFAULT_DROPDOWN_SUBTITLE = 'Наведите камеру устройства\n на QR-код:';
